import { useDrop } from 'react-dnd';
import { Form } from 'react-bootstrap';
import { ItemTypes } from './ItemTypes';

export const DropTarget = () => {
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: ItemTypes.DRAG_SOURCE,
    drop: () => ({ name: 'DropTarget' }),
    collect: (monitor) => ({
      isOver: monitor.isOver(), // Uncommented!
      canDrop: monitor.canDrop(),
    }),
  }))
  
  // Base style
  let style = {
    color: '#198754',
    transition: 'all 0.2s ease-in-out', // Smooth transition for the effect
  }
  
  // When dragging has started (optional: you can add a hint style here if you want)
  if (canDrop) {
    style.opacity = 0.8;
  }

  // When the dragged photo is successfully hovering over the target
  if (isOver) {
    style = {
      ...style,
      boxShadow: 'rgba(0, 0, 0, 0.24) 0px 6px 16px',
      transform: 'scale(1.02)',
      backgroundColor: '#198754',
      color: '#fff',
      opacity: 1
    }
  }

  return (
    <div ref={drop} style={style} className={'drop-target shadow-hover'} data-testid="DropTarget">
      <Form.Label style={{ marginBottom: 0 }}>Drop your photo to accept!</Form.Label>
    </div>
  )
}